//midleware
import React from "react";
import { Navigate, Outlet } from "react-router-dom";

const AuthenticateLoginMiddleware = ({ fallbackPath, module }) => {
      const metUserAndToken = JSON.parse(localStorage.getItem("metUserAndToken"))
      const isAuthenticated = metUserAndToken?.isAuthenticated === true && metUserAndToken?.token;
      if (isAuthenticated) {
            return <Navigate to={fallbackPath} />;
      } else {
            return <Outlet />;
      }
};

export default AuthenticateLoginMiddleware;